import { useState, useEffect } from "react";

const PositionsTableSkeleton = () => {
  const [isPulsing, setIsPulsing] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsPulsing((prev) => !prev);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  const shimmerClass = `${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`;

  return (
    <div className="group-table executed-table flex flex-col gap-3 w-full">
      <div className="rounded-lg border border-n200 bg-p400 shadow-sm w-full">
        <div className="flex justify-between items-center border-b border-n100 px-4 py-3 gap-4">
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
          <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
        </div>

        <div className="px-4 py-3 space-y-3">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="flex justify-between items-center border-b border-n100 last:border-0 py-2 gap-4">
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
              <div className={`h-4 w-20 rounded bg-n200 ${shimmerClass}`}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PositionsTableSkeleton;
